<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'order-reportOrderList',
  components: { PageTable },
}
</script>
